// reducers/errorReducer.js
const initialState = {
    errors: [],
    lastError: null,
    hasActiveError: false
  };
  
  const errorReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'ERROR_OCCURRED':
        // Add new error to the errors array and set it as last error
        return {
          ...state,
          errors: [...state.errors.slice(-9), action.payload], // Keep only last 10 errors
          lastError: action.payload,
          hasActiveError: true
        };
      
      case 'ERROR_ACKNOWLEDGED':
        // Mark error as acknowledged
        return {
          ...state,
          hasActiveError: false,
          lastError: state.lastError ? {
            ...state.lastError,
            acknowledged: true
          } : null
        };
      
      case 'CLEAR_ERRORS':
        // Clear all errors
        return initialState;
        
      default:
        return state;
    }
  };
  
  export default errorReducer;
  
  // Add this reducer to your root reducer setup 
  // In your reducers/index.js:
  
  /*
  import { combineReducers } from 'redux';
  import errorReducer from './errorReducer';
  // import other reducers...
  
  const createRootReducer = (routerReducer) => combineReducers({
    router: routerReducer,
    error: errorReducer,
    // other reducers...
  });
  
  export default createRootReducer;
  */